import React from 'react';

const Icon = ({ size = '88', fill = 'white', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 88 88" fill="none" {...other}>
            <path
                d="M66.667 65.333v3.998a4.004 4.004 0 0 1-4 4.002c-2.21 0-4-1.785-4-4.002v-3.998H29.333v3.998a4.004 4.004 0 0 1-4 4.002c-2.209 0-4-1.785-4-4.002v-3.998c-3.676-.005-6.666-2.993-6.666-6.657V42.657a6.642 6.642 0 0 1 2.973-5.541l4.133-16.541c.835-3.331 4.134-5.908 7.556-5.908h29.344c3.43 0 6.722 2.578 7.554 5.908l4.137 16.549a6.653 6.653 0 0 1 2.97 5.533v16.019a6.663 6.663 0 0 1-6.667 6.657Zm-5.615-43.465c-.24-.959-1.4-1.868-2.38-1.868H29.328c-.973 0-2.14.912-2.38 1.868L23.415 36h41.169l-3.533-14.132h.001ZM20 42.658v16.018c0 .72.605 1.324 1.343 1.324h45.314A1.329 1.329 0 0 0 68 58.676V42.657c0-.72-.605-1.324-1.343-1.324H21.343A1.329 1.329 0 0 0 20 42.657Zm9.333 12.009a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm29.334 0a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"
                fill={fill}
            />
        </svg>
    );
};
export default React.memo(Icon);
